
// localhost
// export const baseURL = "http://localhost/ashesi/admission-fee-manager-api/public/index.php/api/";
// export const baseURLApp = "http://localhost:3000/";
// export const baseURLAppPay="https://sandbox.expresspaygh.com/api";

// export const merchantID = "242633039356";
// export const apiKEY = "RLP1BCxsESqU5hNc1wdVr-BWKJDtabVlr37WxWSBCi-vMZgypQZHjYojRx03bUe-VGqg8Cg1Eu0HqgOs1nA";


// stage
// export const baseURL = "https://stingray-app-zwlrd.ondigitalocean.app/api/";
// export const baseURLApp = "https://dolphin-app-583eh.ondigitalocean.app/";
// export const baseURLAppPay="https://sandbox.expresspaygh.com/api";
// export const merchantID = "242633039356";
// export const apiKEY = "RLP1BCxsESqU5hNc1wdVr-BWKJDtabVlr37WxWSBCi-vMZgypQZHjYojRx03bUe-VGqg8Cg1Eu0HqgOs1nA";

//  //live
export const baseURL = "https://seahorse-app-put3l.ondigitalocean.app/api/";
export const baseURLApp = "https://pay.admissions.ashesi.edu.gh/";
export const baseURLAppPay="https://expresspaygh.com/api";

export const merchantID = "095370042777";
export const apiKEY = "9V9tZjdFodWI6mj3pwJNP-GZYQNhaOR9ObP5Gl7EKP-6jA2B6LgKzZ2c6Q9zn34-qTwt3mmC7eL2u8oHNai";